import { render, staticRenderFns } from "./assessmentGrid.vue?vue&type=template&id=08bc6042&scoped=true&"
import script from "./assessmentGrid.vue?vue&type=script&lang=ts&"
export * from "./assessmentGrid.vue?vue&type=script&lang=ts&"
import style0 from "./assessmentGrid.vue?vue&type=style&index=0&id=08bc6042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc6042",
  null
  
)

export default component.exports